var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokColorful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28063_21389)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 15C30.5 15.1636 30.5 15.3273 30.4844 15.4909C30.3676 19.4182 28.7005 22.987 26.0908 25.5974C23.481 28.2078 19.6249 30 15.4961 30C15.3325 30 15.1689 30 15.0053 29.9844C6.98922 29.7273 0.5 23.0883 0.5 15C0.5 10.8779 2.19047 7.12208 4.90924 4.4026C7.62802 1.68312 11.3751 0 15.4961 0C19.6171 0 23.372 1.68312 26.0908 4.4026C28.8095 7.12208 30.5 10.8779 30.5 15Z",
    fill: "url(#paint0_linear_28063_21389)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4849 15.4914C30.3681 19.4186 28.701 22.9875 26.0912 25.5978C23.4815 28.2082 19.6254 30.0004 15.4966 30.0004H15.0214L15.0058 29.9849C12.9492 27.9277 10.9315 25.9095 8.85156 23.8368C9.89545 24.5381 11.1497 24.9433 12.5052 24.9433C16.1354 24.9433 19.0723 22.0056 19.0723 18.3823V11.1355C20.4667 12.1251 22.1728 12.7173 24.0191 12.7173V9.91992C24.3618 9.99005 24.7124 10.029 25.0629 10.029C26.8157 11.8914 28.6854 13.6602 30.4849 15.4914Z",
    fill: "url(#paint1_linear_28063_21389)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4849 15.4914C30.3681 19.4186 28.701 22.9875 26.0912 25.5978C23.4815 28.2082 19.6254 30.0004 15.4966 30.0004H15.0214L15.0058 29.9849C12.9492 27.9277 10.9315 25.9095 8.85156 23.8368C9.89545 24.5381 11.1497 24.9433 12.5052 24.9433C16.1354 24.9433 19.0723 22.0056 19.0723 18.3823V11.1355C20.4667 12.1251 22.1728 12.7173 24.0191 12.7173V9.91992C24.3618 9.99005 24.7124 10.029 25.0629 10.029C26.8157 11.8914 28.6854 13.6602 30.4849 15.4914Z",
    fill: "#FF1753"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3936 8.41606C20.6769 7.63684 20.2095 6.63164 20.1083 5.51736V5.05762H19.1267C19.376 6.46801 20.2173 7.68359 21.3936 8.41606ZM11.1418 21.055C10.7445 20.5329 10.5263 19.894 10.5263 19.2394C10.5263 17.5797 11.874 16.2394 13.5333 16.2394C13.8449 16.2394 14.1488 16.2862 14.4448 16.3797V12.7485C14.102 12.7018 13.7515 12.6784 13.4087 12.6862V15.5148C13.1127 15.4213 12.8089 15.3745 12.4972 15.3745C10.8379 15.3745 9.49023 16.7226 9.49023 18.3745C9.49023 19.5433 10.1602 20.5641 11.1418 21.055Z",
    fill: "#FF1753"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0718 11.1355C20.4663 12.1329 22.1801 12.7174 24.0186 12.7174V9.91995C22.9903 9.70177 22.0788 9.16411 21.3933 8.41606C20.217 7.68359 19.3756 6.4758 19.1263 5.05762H16.54V19.2394C16.54 20.8914 15.1923 22.2316 13.533 22.2316C12.5592 22.2316 11.6945 21.7641 11.1414 21.0472C10.1598 20.5563 9.48988 19.5355 9.48988 18.3667C9.48988 16.707 10.8376 15.3667 12.4969 15.3667C12.8163 15.3667 13.1201 15.4135 13.4083 15.507V12.6784C9.84823 12.7485 6.98145 15.6628 6.98145 19.2394C6.98145 21.0239 7.69814 22.6446 8.85109 23.829C9.89497 24.5303 11.157 24.9355 12.5047 24.9355C16.1271 24.9355 19.0718 21.9979 19.0718 18.3745V11.1277V11.1355Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0185 9.91965V9.16381C23.0915 9.16381 22.18 8.90667 21.3932 8.41576C22.0943 9.1794 23.0136 9.70927 24.0185 9.91965ZM19.1263 5.05732C19.1029 4.92485 19.0873 4.78459 19.0718 4.65212V4.19238H15.4961V18.3742C15.4961 20.0261 14.1484 21.3664 12.489 21.3664C12.0061 21.3664 11.5464 21.2495 11.1413 21.0469C11.6867 21.7638 12.5592 22.2313 13.5329 22.2313C15.1845 22.2313 16.5322 20.8911 16.5399 19.2391V5.05732H19.1263ZM13.4083 12.6781V11.8755C13.1123 11.8365 12.8084 11.8132 12.5046 11.8132C8.8744 11.8132 5.9375 14.7508 5.9375 18.3742C5.9375 20.6495 7.09045 22.6521 8.85103 23.8287C7.69029 22.6443 6.98138 21.0236 6.98138 19.2391C6.98138 15.6625 9.84817 12.7482 13.4083 12.6781Z",
    fill: "#00C9D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1074 11.9926C21.5018 12.99 23.2157 13.5744 25.0542 13.5744V10.0212C24.7036 10.0212 24.3531 9.98224 24.0181 9.91211V12.7095C22.1718 12.7095 20.4658 12.1251 19.0713 11.1277V18.3744C19.0713 21.9978 16.1344 24.9355 12.5042 24.9355C11.1487 24.9355 9.89447 24.5303 8.85059 23.829C10.0425 25.0446 11.7018 25.8004 13.5481 25.8004C17.1783 25.8004 20.1152 22.8628 20.1152 19.2394V11.9926H20.1074Z",
    fill: "#FF1753"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28063_21389",
    x1: 5.86744,
    y1: 3.52208,
    x2: 25.1384,
    y2: 26.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28063_21389",
    x1: 5.85234,
    y1: 3.19525,
    x2: 25.287,
    y2: 26.3487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28063_21389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokColorful);
export default __webpack_public_path__ + "static/media/tiktok-colorful.9aed41aa.svg";
export { ForwardRef as ReactComponent };